// extracted by mini-css-extract-plugin
export default {"portfolio":"Portfolio_portfolio__CiLSr","title":"Portfolio_title__1y1gr","card":"Portfolio_card__WeShe","button":"Portfolio_button__M8N-y","btncnt":"Portfolio_btncnt__FyDML"};